export default function debounce(f, delay) {
  let timer;
  return function (event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(f, delay, event);
  };
}
